module.exports = __webpack_public_path__ + "static/media/aula1.62afb884.jpg";